<div class="container" *ngIf="editDealerServiceForm">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center">
                <div class="popup-title mr-auto" translate>lblEditDealerService</div>
                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
            </div>
            <ng-container *ngIf="editDealerServiceForm">
                <form [formGroup]="editDealerServiceForm" (ngSubmit)="onSubmit()">
                    <div class="scrollbar">
                        <div class="card-content">
                            <div class="card-body p-0">
                                <div class="form-row">
                                    <div class="col-6 af-form-group">
                                        <label for="typeahead-format" translate>lblSelectDealer <span class="text-danger">*</span></label>
                                        <div class="lbl-info">
                                            <ng-container *ngIf="dealerList && dealerList.length > 0; else SimpleInput">
                                                <app-dealer-searchbox [dealerList]="dealerList" formControlName="dealer">
                                                </app-dealer-searchbox>
                                            </ng-container>
                                            <ng-template #SimpleInput>
                                                <input type="text" formControlName="dealer" class="form-control mb-2" placeholder="Search Dealer">
                                            </ng-template>
                                            <div *ngIf="(cpf.dealer.touched || cpf.dealer.dirty) && cpf.dealer.errors">
                                                <div *ngIf="cpf.dealer.errors.required" class="help-block mt-1 text-danger" translate>
                                                    lblDealerNameRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 af-form-group">
                                        <label for="service-category" translate>lblServiceCategory <span
                        class="text-danger">*</span></label>
                                        <div class="lbl-info">
                                            <input type="text" formControlName="serviceCategory" id="service-category" class="form-control mb-2">
                                        </div>
                                    </div>

                                    <div class="col-6 af-form-group">
                                        <label for="service" translate>lblService <span class="text-danger">*</span></label>
                                        <div class="lbl-info">
                                            <input type="text" formControlName="service" id="service" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-6 af-form-group">
                                        <label for="duration"><span translate>lblDuration</span> <span class="text-danger">*</span></label>
                                        <div class="lbl-info">
                                            <input type="text" formControlName="duration" class="form-control mb-2" 
                                            [ngClass]="{'is-invalid': (cpf.duration.touched || cpf.duration.dirty) && cpf.duration.errors}"
                                             (keypress)="isDigit($event)" placeholder="hh:mm" maxlength="5" id="duration"
                                             pattern="^\d{2}:\d{2}$" (input)="CheckDuration($event)">
                                            <div *ngIf="(cpf.duration.touched || cpf.duration.dirty) && cpf.duration.errors">
                                                <div *ngIf="cpf.duration.errors.required" class="help-block mt-1 text-danger" translate>
                                                    lblDurationRequired
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4 af-form-group">
                                        <label for="price" translate>lblDealerPrice<span class="text-sm1" translate>lblExclVat</span> <span class="text-danger">*</span></label>
                                        <div class="lbl-info">
                                            <input type="text" formControlName="price" class="form-control mb-2" [ngModel]="dealerServiceBusinessService.dealerServiceDetails.price | stringToNumber | number:'1.2-2'" [ngClass]="{'is-invalid': (cpf.price.touched || cpf.price.dirty) && cpf.price.errors}" pattern="^[\d,.\s]+$" placeholder="Enter Price"
                                                maxlength="10" id="price" (blur)="onBlur($event)">
                                            <div *ngIf="(cpf.price.touched || cpf.price.dirty) && cpf.price.errors">
                                                <div *ngIf="cpf.price.errors.required" class="help-block mt-1 text-danger" translate>
                                                    lblPriceRequired
                                                </div>
                                            </div>
                                            <div *ngIf="cpf.price.touched && (cpf.price.errors?.pattern)" class="help-block mt-1 text-danger" translate>
                                                lblOnlyNumbersAreAllowed
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-2 af-form-group">
                                        <label for="price" translate>lblDealerPrice <span class="text-sm1" translate>lblInclVAT</span><span class="text-danger">*</span></label>
                                        <div class="lbl-info">
                                            <input type="text" formControlName="priceInclVAT" class="form-control mb-2" 
                                            [ngModel]="dealerServiceBusinessService.dealerServiceDetails.priceInclVAT | stringToNumber | number:'1.2-2'"  disabled>
                                        </div>
                                    </div>
                                    
                                    <div class="col-6 af-form-group">
                                        <label for="description" translate>lblDescription</label>
                                        <div class="lbl-info">
                                            <textarea formControlName="description" class="form-control" placeholder="Enter Description" cols="3" maxlength="200" id="Description"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-6 af-form-group" *ngIf="isFixed">
                                        <label for="fixedPrice">
                                    <span translate>lblFixedPrice<span class="text-sm1" translate>lblExclVat</span></span>
                                    </label>
                                        <div class="lbl-info">
                                            <input type="text" class="form-control mb-2" disabled [ngModel]="FixedPrice | number:'1.2-2'" 
                                            [ngModelOptions]="{standalone: true}" (ngModelChange)="onChecked(obj, $event)" >
                                        </div>
                                    </div>



                                    <div class="col-6">
                                        <div class="form-row">
                                            <div class="col-md-12 af-form-group">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                                                    <label class="custom-control-label" for="isActive">
                            <span translate>lblActive</span>
                          </label>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" id="isDisplayPriceInWidget" formControlName="isDisplayPriceInWidget">
                                                    <label class="custom-control-label" for="isDisplayPriceInWidget">
                            <span translate>lblDisplayPriceInWidget</span>
                          </label>
                                                </div>
                                            </div>
                                           
                                           
                                        </div>


                                    </div>

                                    <div class="col-6">
                                        <div class="form-row">
                                           
                                           
                                            <div class="col-md-6 af-form-group">

                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" id="isRecommended" formControlName="isRecommended" disabled>
                                                    <label class="custom-control-label" for="isRecommended">
                            <span translate>lblRecommendedService</span>
                          </label>
                                                </div>
                                            </div>
                                            <div class="col-md-6 af-form-group">

                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" id="needAttention" formControlName="needAttention">
                                                    <label class="custom-control-label" for="needAttention">
                            <span translate>lblNeedAttention</span>
                          </label>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="lbl-info">
                                                    <span translate class="ml-2 mr-2" style="color: #17252a;
                        font-size: 14px;">lblServiceisFixedPriceofServiceis</span>
                                                    <ng-container *ngIf="isFixed; else load_else">
                                                        <em class="fas fa-check"></em>
                                                    </ng-container>
                                                    <ng-template #load_else>
                                                        <em class="fas fa-times text-danger"></em>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                    <div class="col-12">
                                    
                                    
                                        <div class="mt-4 ctm-tab custom-card card-accord">
                                            <ngb-accordion #a="ngbAccordion" activeIds="ngb-panel-0" class="overflow-none-card">
                                                <ngb-panel title="first">
                                                    <ng-template ngbPanelHeader class="custom-header ctm">
                                                        <div class="d-flex align-items-center">
                                                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left"
                                                                aria-label="Center Align" translate>
                                                                lblDurationAndPriceForServiceBooking
                                                                <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                                                        class="fas fa-angle-down fa-lg ml-auto"></em>
                                                                </ng-container>
                                                                <ng-container *ngIf="a.activeIds.includes('first')"><em
                                                                        class="fas fa-angle-up fa-lg ml-auto"></em>
                                                                </ng-container>
                                                            </button>
                                                        </div>
                                                    </ng-template>
                                                    <ng-template ngbPanelContent>
                                    
                                                        <div class="table-responsive editservicetblresponsive">
                                                            <div *ngFor="let serviceFilter of ServiceFilterForm; let in=index;let last=last">
                                                                <app-service-duration-price [in]=in [service]="serviceDetails" [isAddView]="true"
                                                                    [serviceFilter]="serviceFilter" (addServiceTimeDetailSlotOpt)="AddServiceFilter($event)"
                                                                    (removeServiceTimeDetailSlotOpt)="RemoveServiceFilter($event)">
                                                                </app-service-duration-price>
                                                            </div>
                                                        </div>
                                    
                                                    </ng-template>
                                                </ngb-panel>
                                    
                                            </ngb-accordion>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-3 bg-light pp-footer-top-brdr">
                        <div class="row">
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                                <button class="btn btn-primary mr-sm-2 btn-lg" translate aria-label="Center Align" [disabled]="editDealerServiceForm.invalid">lblSaveChanges
                                </button>
                                <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
        </div>
    </div>
</div>
